export default (str) =>
  encodeURIComponent(str)
    .replace(/-/gi, "%2D")
    .replace(/_/gi, "%5F")
    .replace(/\./gi, "%2E")
    .replace(/\!/gi, "%21")
    .replace(/\*/gi, "%2A")
    .replace(/\)/gi, "%29")
    .replace(/\(/gi, "%28");



// WEBPACK FOOTER //
// ./app/frontend/components/getEncodedURI.js